import React, { useState } from "react";
import "../../../../../Modal/dialog.css";
const DialogBoxContactViaZapierApp = ({ obj, modalCloseContactViaZapierApp,modalOpenContactViaZapierApp, changeSwitchApp, checkedOnOFF, switchValue, labelONOFFC, saveWebhooks, webhooks_title, webhooks_url, webhooks_id, onChangesWebhooks }) => {
	const modalCloseContactViaBoxZapierHere = () => {
		modalCloseContactViaZapierApp(false, '')
		//setOption("static")


	}

	return (
		<React.Fragment>
			<div
				className={obj.modalContactViaObjectZapierApp.show ? "modal fade yr-upgrade-popup white-bg new-model-popup show" : "modal fade yr-upgrade-popup white-bg new-model-popup"}
				style={{ display: obj.modalContactViaObjectZapierApp.show ? "block" : "none" }}
				id="modalContactViaID"
			>
				<div className="modal-dialog modal-dialog-centered" role="document">
					{obj.modalContactViaObjectZapier.loading && <div className="ui loading form"></div>}
					<div className="modal-content yr-campaigns-model">
						<button
							type="button"
							className="close linear-gradient"
							data-dismiss="modal"
							aria-label="Close"
							onClick={() => modalCloseContactViaBoxZapierHere()}
						>
							X
						</button>
						<div className="modal-header" style={{ paddingBottom: '0px !important' }}>

							<h5 className="modal-title">{obj.modalContactViaObjectZapierApp.title}</h5>
							{/* <div style={{
								marginTop: '1.3rem',
								marginRight: '1.5rem'
							}}>
								<label className="mr-2">Turn {switchValue == 'ON' ? 'off to disable' : 'on to enable'} zapier app</label>
								<span className="kt-switch kt-switch-sm kt-switch--success chat-cus-check">
									<label style={{ marginBottom: '-0.85rem', marginTop: 0 }}>
										<input
											name="modetype"
											id="ctl00_bc_custom_element_43"
											type="checkbox"
											value={switchValue}
											onClick={(e) => changeSwitchApp(e)}
											checked ={switchValue == 'ON'?"checked":""}
										/>
										<span />
									</label>
								</span>
							</div> */}
						</div>
						<div class="modal-body">
							<form class="kt-form">
								<div id="AddEditContactFormModalBody" class="modal-body"
									style={{ padding: "0 3.25rem", maxHeight: "500px", overflow: "auto" }}>
									<div class="kt-portlet__body py-0">

										
                            <div style={{
								marginTop: '1.3rem',
								marginRight: '1.5rem'
							}}>
								<label className="mr-2">Turn {switchValue == 'ON' ? 'off to disable' : 'on to enable'} zapier app</label>
								<span className="kt-switch kt-switch-sm kt-switch--success chat-cus-check">
									<label style={{ marginBottom: '-0.85rem', marginTop: 0 }}>
										<input
											name="modetype"
											id="ctl00_bc_custom_element_43"
											type="checkbox"
											value={switchValue}
											onClick={(e) => changeSwitchApp(e)}
											checked ={switchValue == 'ON'?"checked":""}
										/>
										<span />
									</label>
								</span>
							</div>
									</div>
								</div>
								<div class="kt-portlet__foot">
									<div class="kt-form__actions">
										<div class="form-group row">
											<div class="col-lg-12 d-flex justify-content-end align-items-center">
												<button type="reset" onClick={() => modalCloseContactViaBoxZapierHere()} class="btn linear-gradient yr-cancelbtn ml-4" style={{ minWidth: 'unset' }}><span style={{color:"black"}}>Cancel</span></button>
												<button type="reset" onClick={() => modalOpenContactViaZapierApp()} class="btn linear-gradient yr-submitbtn ml-4" style={{ minWidth: 'unset' }}><span>Save</span></button>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default DialogBoxContactViaZapierApp;